import { createReducer } from '@reduxjs/toolkit';

import * as spacerActions from './spacerActions.js';

const initialState = {
  requesting: false,
  error: null,

  id: 0,
  uid: 0,
  type: 'spacer',
  isActive: false,

  height: 0,
  view: '1',
};

const spacer = createReducer(initialState, (builder) => {
  builder
    .addCase(spacerActions.spacerUpdateId, (state, { payload: id }) => ({ ...state, id }))
    .addCase(spacerActions.spacerUpdateIsActive, (state, { payload: isActive }) => ({ ...state, isActive }))

    .addCase(spacerActions.spacerStore, (state, { payload: data }) => {
      const {
        blockId,
        uid,
        isActive,

        spacer,
      } = data;

      const section = spacer ?? {};
      const { height, view } = section;

      return {
        ...state,

        error: null,
        requesting: false,

        id: blockId ?? 0,
        uid: uid ?? 0,
        isAdded: isActive,

        height: height ?? 0,
        View: view ?? '1',
      };
    })
    .addCase(spacerActions.spacerClear, () => ({ ...initialState }))

    .addCase(spacerActions.spacerUpdateRequest, (state) => ({ ...state, requesting: true, error: null }))
    .addCase(spacerActions.spacerUpdateError, (state, { payload }) => ({ ...state, error: payload, requesting: false }))
    .addCase(spacerActions.spacerUpdateStore, (state) => ({ ...state, error: false, requesting: false }))

    .addCase(spacerActions.spacerUpdateHeight, (state, { payload: height }) => ({ ...state, height }))
    .addCase(spacerActions.spacerUpdateView, (state, { payload: view }) => ({ ...state, view }));
});

export default spacer;
